import { createReducer } from 'src/helpers/reducer';
import actionTypes from './actionTypes';
import type { IRateEngineFormData, IRateEngineFormDataState } from './types';

const initState: IRateEngineFormDataState = {
  data: null,
  isLoading: false,
  hasError: false,
};

function onFetchRequest(state: IRateEngineFormDataState): IRateEngineFormDataState {
  return { ...state, isLoading: true, hasError: false };
}

function onFetchSuccess(
  state: IRateEngineFormDataState,
  { payload }: { payload: { data: IRateEngineFormData } },
): IRateEngineFormDataState {
  return { ...state, data: payload.data, isLoading: false, hasError: false };
}

function onFetchError(state: IRateEngineFormDataState): IRateEngineFormDataState {
  return { ...state, isLoading: false, hasError: true };
}

export default createReducer(initState, {
  [actionTypes.FETCH_REQUEST]: onFetchRequest,
  [actionTypes.FETCH_SUCCESS]: onFetchSuccess,
  [actionTypes.FETCH_ERROR]: onFetchError,
});
